export default "__VITE_ASSET__55775d18__"